import request from '@/utils/server'
// 新增总仓
export function addHouse(data) {
    return request({
      url: '/inventory/addHouse',
      method: 'POST',
      data: data
    })
  }
//   删除总仓
export function deleteHouse(data) {
    return request({
      url: '/inventory/deleteHouse',
      method: 'POST',
      data: data
    })
  }
  // 修改总仓
  export function updateHouse(data) {
    return request({
      url: '/inventory/updateHouse',
      method: 'POST',
      data: data
    })
  }
//  获取总仓
 export function getHouseList(query) {
    return request({
      url: '/inventory/getHouseList',
      method: 'get',
      params: query
    })
  }
  // 获取子仓
  export function getHouseListByPid(query) {
    return request({
      url: '/inventory/getHouseListByPid',
      method: 'get',
      params: query
    })
  }